
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import SettingsIcon from '@material-ui/icons/Settings';
import { Tooltip, Zoom, IconButton } from '@material-ui/core';
import React, { useState } from 'react';
import { dispositivo } from "../../../components/Dispositivos";

import { updateTratamiento, updateTratamientoInArray } from '../../../redux/tratamientos/tratamientosActions';
const TratamientoCard = ({ idx, item, subGrupos, onPersonalizar }) => {
  const subGrupo = subGrupos.find((it) => it.id === item.subGrupoId);
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [cambio, setCambio] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const esBase = item.origen === "base";

  const handleOnBlur = () => {
    try {
      if (cambio && item.origen !== "base") {
        dispatch(updateTratamiento(item.empresaId, item));
        setCambio(false);
        addToast("Tratamiento actualizado", { appearance: "success" });
      }
    } catch (err) {
      addToast(err.message, { appearance: "error" });
    }
  };

  const handleChange = (e) => {
    try {
      if (item.origen === "base") {
        addToast("Debe personalizar este tratamiento antes de modificarlo", { appearance: "info" });
        return;
      }

      const { name, value, checked } = e.target;
      let updated = { ...item };

      if (["precio", "costo", "tiempo"].includes(name)) {
        setCambio(true);
        updated[name] = Number(value);
        dispatch(updateTratamientoInArray(updated));
      }

      if (name === "estado") {
        updated.activo = checked;
        dispatch(updateTratamiento(updated.empresaId, updated));
        addToast("Tratamiento actualizado", { appearance: "success" });
      }
    } catch (err) {
      addToast(err.message, { appearance: "error" });
    }
  };

  if (!subGrupo) return null;

  return (
    <CardContainer esBase={esBase}>
      <CardHeader onClick={() => setIsExpanded(!isExpanded)}>
        <Index>{idx + 1}</Index>
        <ColorCircle color={subGrupo.color} />
        <MainInfo>
          <TratamientoName>{item.tratamiento}</TratamientoName>
          <SecondaryInfo>
            <span>{item.tipo}</span>
            <span>{item.especialidad}</span>
          </SecondaryInfo>
        </MainInfo>
        <StatusToggle>
          <input
            name="estado"
            type="checkbox"
            checked={item.activo}
            onChange={handleChange}
          />
          <ExpandIcon>{isExpanded ? '−' : '+'}</ExpandIcon>
        </StatusToggle>
      </CardHeader>

    <CardBody isExpanded={isExpanded}>
  <div className="input-group">
    <div className="input-row">
      <label>Sub. Grupo:</label>
      <span>{subGrupo.nombre}</span>
    </div>
  </div>

  <div className="input-group">
    <div className="input-row">
      <label>Precio:</label>
      <input
        name="precio"
        value={item.precio}
        type="number"
        onBlur={handleOnBlur}
        onChange={handleChange}
      />
    </div>

    <div className="input-row">
      <label>Costo:</label>
      <input
        name="costo"
        value={item.costo}
        type="number"
        onBlur={handleOnBlur}
        onChange={handleChange}
      />
    </div>

    <div className="input-row">
      <label>Tiempo (min):</label>
      <input
        name="tiempo"
        value={item.tiempo}
        type="number"
        onBlur={handleOnBlur}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="actions">
    <Tooltip title="Configurar tratamiento">
      <button 
        onClick={() => onPersonalizar(item)}
        className="personalizar-btn"
      >
        <SettingsIcon fontSize="small" />
        <span>Personalizar</span>
      </button>
    </Tooltip>
  </div>
</CardBody>
    </CardContainer>
  );
};

export default TratamientoCard;


// Estilos
const CardContainer = styled.div`
  background-color: ${props => props.esBase ? '#f8f9fa' : 'white'};
  opacity: ${props => props.esBase ? 0.8 : 1};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 1rem;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  background-color: inherit;
`;

const Index = styled.span`
  font-weight: 500;
  margin-right: 1rem;
  min-width: 20px;
`;

const ColorCircle = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${props => props.color};
  margin-right: 1rem;
  border: 1px solid #ddd;
`;

const MainInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const TratamientoName = styled.span`
  font-weight: 500;
  margin-bottom: 0.25rem;
`;

const SecondaryInfo = styled.div`
  display: flex;
  gap: 1rem;
  font-size: 0.875rem;
  color: #666;
`;

const StatusToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  input[type="checkbox"] {
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  }
`;

const ExpandIcon = styled.span`
  font-size: 1.25rem;
  font-weight: bold;
  width: 24px;
  text-align: center;
`;

const CardBody = styled.div`
  display: ${props => props.isExpanded ? 'block' : 'none'};
  padding: 0 1rem 1rem 1rem;
  border-top: 1px solid #eee;
  overflow: hidden; /* Asegura que nada se desborde */

  /* Contenedor de inputs */
  .input-group {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    margin-top: 1rem;

    @media ${dispositivo.mobileL} {
      grid-template-columns: 1fr;
    }
  }

  /* Cada fila de input */
  .input-row {
    display: flex;
    flex-direction: column;
    min-width: 0; /* Previene desbordamiento */

    label {
      font-size: 0.8rem;
      color: #666;
      margin-bottom: 0.25rem;
      font-weight: 500;
    }

    input {
      width: 100%;
      padding: 0.5rem;
      border: 1px solid #ddd;
      border-radius: 4px;
      box-sizing: border-box;

      &:read-only {
        background-color: #f5f5f5;
      }
    }
  }

  /* Botones de acción */
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 1rem;
    flex-wrap: wrap; /* Para móviles muy pequeños */

    button {
      padding: 0.5rem 1rem;
      border-radius: 4px;
      font-size: 0.9rem;
    }
  }
`;
const DetailRow = styled.div`
  display: flex;
  margin-bottom: 1rem;
  align-items: center;
`;

const Label = styled.span`
  font-weight: 500;
  min-width: 100px;
  color: #666;
  font-size: 0.875rem;

  @media ${dispositivo.mobileL} {
    min-width: 120px;
  }
`;

const Value = styled.span`
  flex: 1;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;

  @media ${dispositivo.tablet} {
    flex-direction: row;
  }
`;

const InputContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const StyledInput = styled.input`
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-width: 120px;

  &:read-only {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledIconButton = styled(IconButton)`
  && {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #1976d2;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    background-color: rgba(25, 118, 210, 0.04);

    &:hover {
      background-color: rgba(25, 118, 210, 0.08);
    }

    span {
      font-size: 0.875rem;
      font-weight: 500;
    }

    @media ${dispositivo.mobileL} {
      padding: 0.5rem;
      span {
        display: none;
      }
    }
  }
`;
